
/**
 * This is a placeholder in the settings, which must be replaced with "2sxc" or another term for other dnn extensions
 * @internal
 */
export const ApiExtensionPlaceholder = 'e.x.t';

/**
 * The special header meta tag containing settings for 2sxc
 * @internal
 */
export const MetaHeaderJsApi = '_jsApi';

/**
 * The fallback path to the UI
 * @internal
 */
export const DnnUiRoot = '/desktopmodules/tosic_sexycontent/';

/**
 * @internal
 */
export const PlatformOqtane = 'oqtane';

/**
 * @internal
 */
export const PlatformDnn = 'dnn';

/**
 * The fallback AntiForgery token header name (as in Dnn)
 * @internal
 */
export const AntiForgeryTokenHeaderNameDnn = 'RequestVerificationToken';
